(function () {
  'use strict';
  function setup(root) {
    if (root.dataset.ready) return;
    const form = root.querySelector('form');
    if (!form) return;
    const success = root.querySelector('.bpi-success');
    if (success) { success.focus(); return; }
    const panels = Array.from(root.querySelectorAll('[data-inquiry-panel]'));
    if (panels.length !== 4) return;
    const heading = root.querySelector('[data-inquiry-heading]');
    const progress = root.querySelector('.bpi-progress');
    const next = root.querySelector('[data-inquiry-next]');
    const back = root.querySelector('[data-inquiry-back]');
    const submit = root.querySelector('[data-inquiry-submit]');
    const selection = root.querySelector('[data-inquiry-selection]');
    const status = root.querySelector('[data-inquiry-status]');
    const radios = Array.from(root.querySelectorAll('input[name="contact[service]"]'));
    const titles = ['What are you planning?', 'Your vehicle. Your application.', 'Tell us about the project.', 'Let’s take the next step.'];
    let step = 0;
    let furthest = 0;
    function chosen() { return radios.find(r => r.checked); }
    function service() { return chosen() ? chosen().value : 'performance'; }
    function label() { return chosen() ? chosen().dataset.serviceLabel : 'Performance builds'; }
    function updateRelevant() {
      const key = service();
      root.querySelectorAll('[data-service-fields]').forEach(group => {
        const relevant = group.dataset.serviceFields.split(' ').includes(key);
        group.hidden = !relevant;
        group.querySelectorAll('input,select,textarea').forEach(el => { el.disabled = !relevant; });
      });
      const unknown = root.querySelector('[data-no-vehicle]').checked;
      root.querySelectorAll('[data-vehicle-fields] input,[data-vehicle-fields] select').forEach(el => {
        el.disabled = unknown || key === 'other';
      });
      if (key === 'other') root.querySelector('[data-no-vehicle]').disabled = true;
      else root.querySelector('[data-no-vehicle]').disabled = false;
    }
    function validate(panel) {
      const controls = Array.from(panel.querySelectorAll('input,select,textarea')).filter(el => !el.disabled);
      for (const el of controls) {
        if (!el.checkValidity()) { el.reportValidity(); return false; }
      }
      return true;
    }
    function review() {
      const box = root.querySelector('[data-inquiry-review]');
      const dl = box.querySelector('dl');
      dl.replaceChildren();
      function row(key, value) {
        const dt = document.createElement('dt'); dt.textContent = key;
        const dd = document.createElement('dd'); dd.textContent = value;
        dl.append(dt, dd);
      }
      row('Service', label());
      if (service() !== 'other') {
        if (root.querySelector('[data-no-vehicle]').checked) row('Vehicle', 'Application unknown / not vehicle-specific');
        else {
          const values = ['year','make','model'].map(key => root.querySelector('[name="contact[' + key + ']"]').value.trim());
          row('Vehicle', values.filter(Boolean).join(' '));
        }
        panels[2].querySelectorAll('input,select,textarea').forEach(el => {
          if (el.disabled || !el.value.trim()) return;
          const fieldLabel = el.closest('.fld').querySelector('label').textContent.replace('*','').trim();
          row(fieldLabel, el.value.trim());
        });
      } else {
        const topic = root.querySelector('[name="contact[topic]"]').value;
        const order = root.querySelector('[name="contact[order_number]"]').value;
        if (topic) row('Topic', topic);
        if (order) row('Order', order);
      }
      box.hidden = false;
    }
    function show(target, focus) {
      step = target;
      updateRelevant();
      panels.forEach((panel, i) => { panel.hidden = i !== step; });
      const general = service() === 'other';
      progress.querySelectorAll('button').forEach((button, i) => {
        button.disabled = i > furthest || (general && (i === 1 || i === 2));
        if (i === step) button.setAttribute('aria-current','step');
        else button.removeAttribute('aria-current');
      });
      heading.textContent = titles[step];
      back.hidden = step === 0;
      next.hidden = step === 3;
      submit.hidden = step !== 3;
      submit.type = step === 3 ? 'submit' : 'button';
      next.querySelector('span').textContent = general ? 'Continue to contact' : ['Continue to vehicle','Continue to project','Continue to contact'][step] || 'Continue';
      selection.textContent = label() + ' selected';
      status.textContent = '';
      if (step === 3) review();
      if (focus) { heading.focus({preventScroll:true}); root.scrollIntoView({behavior:'instant',block:'start'}); }
    }
    radios.forEach(radio => radio.addEventListener('change', () => {
      furthest = 0;
      show(0, false);
    }));
    root.querySelector('[data-no-vehicle]').addEventListener('change', updateRelevant);
    next.addEventListener('click', () => {
      if (!validate(panels[step])) return;
      const target = service() === 'other' ? 3 : step + 1;
      furthest = Math.max(furthest, target);
      show(target, true);
    });
    back.addEventListener('click', () => { show(service() === 'other' ? 0 : step - 1, true); });
    progress.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      const target = Number(button.dataset.inquiryStep);
      if (target > step && !validate(panels[step])) return;
      show(target, true);
    }));
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && step < 3 && event.target.matches('input')) { event.preventDefault(); next.click(); }
    }, true);
    submit.addEventListener('click', event => {
      const relevantSteps = service() === 'other' ? [0,3] : [0,1,2,3];
      for (const i of relevantSteps) {
        const invalid = Array.from(panels[i].querySelectorAll('input,select,textarea')).find(el => !el.disabled && !el.checkValidity());
        if (invalid) { event.preventDefault(); event.stopImmediatePropagation(); show(i, true); invalid.reportValidity(); return; }
      }
    }, true);
    form.addEventListener('submit', event => {
      updateRelevant();
      const relevantSteps = service() === 'other' ? [0,3] : [0,1,2,3];
      for (const i of relevantSteps) {
        const invalid = Array.from(panels[i].querySelectorAll('input,select,textarea')).find(el => !el.disabled && !el.checkValidity());
        if (invalid) { event.preventDefault(); show(i, true); invalid.reportValidity(); return; }
      }
      if (step !== 3) { event.preventDefault(); furthest = 3; show(3, true); return; }
      // Native Shopify POST handles spam checks, server errors and receipt confirmation.
      status.textContent = 'Sending your request…';
    });
    const requested = new URLSearchParams(window.location.search).get('service') || root.dataset.defaultService;
    const preset = radios.find(r => r.value === requested);
    if (preset) preset.checked = true;
    else if (!chosen()) radios[0].checked = true;
    form.noValidate = false;
    root.dataset.ready = 'true';
    root.classList.add('is-guided');
    progress.hidden = false;
    show(0, false);
    if (root.querySelector('.bpi-errors').textContent.trim()) {
      furthest = 3; show(3, false);
      status.textContent = 'Please check the message above and your contact details, then try again.';
    }
  }
  function init() { document.querySelectorAll('[data-inquiry]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
